import React from 'react';

export const getStatusBadge = (status: string): JSX.Element => {
    switch (status.toLowerCase()) {
        // Booking Statuses
        case 'pending':
            return <span className="badge badge-soft-warning">Pending</span>;
        case 'approved':
            return <span className="badge badge-soft-success">Approved</span>;
        case 'cancelled':
            return <span className="badge badge-soft-danger">Cancelled</span>;
        case 'completed':
            return <span className="badge badge-soft-success">Completed</span>;
        case 'deleted':
            return <span className="badge badge-soft-danger">Deleted</span>;
        
        // Payment Statuses
        case 'invoice_sent':
            return <span className="badge badge-soft-info">Invoice Sent</span>;
        case 'awaiting_deposit':
            return <span className="badge badge-soft-warning">Awaiting Deposit</span>;
        case 'deposit_collected':
            return <span className="badge badge-soft-info">Deposit Collected</span>;
        case 'paid':
            return <span className="badge badge-soft-success">Paid</span>;
        case 'payment_overdue':
            return <span className="badge badge-soft-danger">Payment Overdue</span>;
        case 'refunded':
            return <span className="badge badge-soft-secondary">Refunded</span>;
        default:
            return <span className="badge badge-soft-secondary">Not specified</span>;
    }
};

export const getSolidStatusBadge = (status: string): JSX.Element => {
    switch (status.toLowerCase()) {
        // Booking Statuses
        case 'pending':
            return <span className="badge bg-warning">Pending</span>;
        case 'approved':
            return <span className="badge bg-success">Approved</span>;
        case 'cancelled':
            return <span className="badge bg-danger">Cancelled</span>;
        case 'completed':
            return <span className="badge bg-success">Completed</span>;
        case 'deleted':
            return <span className="badge bg-danger">Deleted</span>;
        
        // Payment Statuses
        case 'invoice_sent':
            return <span className="badge bg-info">Invoice Sent</span>;
        case 'awaiting_deposit':
            return <span className="badge bg-warning">Awaiting Deposit</span>;
        case 'deposit_collected':
            return <span className="badge bg-info">Deposit Collected</span>;
        case 'paid':
            return <span className="badge bg-success">Paid</span>;
        case 'payment_overdue':
            return <span className="badge bg-danger">Payment Overdue</span>;
        case 'refunded':
            return <span className="badge bg-secondary">Refunded</span>;
        default:
            return <span className="badge bg-secondary">Not specified</span>;
    }
};

export interface StatusResponse {
    badge: JSX.Element;
    type: 'booking_status' | 'payment_status';
}

export const getStatusFromSlug = (slug: string): StatusResponse => {
    const slugLower = slug.toLowerCase();
    let type: 'booking_status' | 'payment_status';
    
    switch (slugLower) {
        // Booking Statuses
        case 'pending':
        case 'approved':
        case 'cancelled':
        case 'completed':
            type = 'booking_status';
            break;

        // Payment Statuses
        case 'invoice_sent':
        case 'awaiting_deposit':
        case 'deposit_collected':
        case 'paid':
        case 'payment_overdue':
        case 'refunded':
            type = 'payment_status';
            break;

        default:
            type = 'booking_status'; // Default fallback
    }

    return {
        badge: getStatusBadge(slugLower),
        type
    };
};
